<template>
  <BaseDialogForm
    v-model="showDriverStatusChangedDialog"
    maxWidth="50vw"
    :nonFieldErrors="formErrors.non_field_errors"
    :title="`${statusMapping.driverStatus} Update`"
  >
    <template #content>
      <v-form v-model="isValid" ref="assignmentForm">
        <SelectField
          id="vehicle"
          name="vehicle"
          v-if="!currentDriverStatus"
          :itemsList="vehicleList"
          itemText="vehicle_number"
          itemValue="id"
          :errorMessages="formErrors.vehicle"
          :isClearable="true"
          :isSearchRequired="true"
          :label="`Select ${fleetModule.vehicle}`"
          v-model="assignmentForm.vehicle"
        />
        <TextAreaField
          v-else
          id="deactivation_remarks"
          name="deactivation_remarks"
          v-model="assignmentForm.deactivation_remarks"
          :rules="[(val) => !!val || 'Deactivation remarks are required']"
          label="Deactivation Remarks*"
        />
      </v-form>
    </template>
    <template #actions>
      <v-btn
        id="driverStatusChangeSubmit"
        depressed
        color="primary"
        :disabled="!isValid"
        @click="updateDriverStatusDetails"
        >Submit</v-btn
      >
    </template>
  </BaseDialogForm>
</template>

<script>
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { bus } from "@/main";
import { fleetModule, statusMapping } from "@/utils/moduleMapping";
export default {
  components: { BaseDialogForm },
  emits: ["refreshList"],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    currentDriverStatus: {
      type: Boolean,
    },
    driverID: {
      type: Number,
    },
  },
  data() {
    return {
      statusMapping,
      fleetModule,
      assignmentForm: {},
      formErrors: {},
      isValid: true,

      vehicleList: [],
    };
  },
  watch: {
    value(val) {
      if (val) {
        if (!this.currentDriverStatus) {
          this.getVehicleList();
        }
      } else {
        this.$refs.assignmentForm.resetValidation();
        this.assignmentForm = {};
      }
    },
  },
  computed: {
    showDriverStatusChangedDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    updateDriverStatusDetails() {
      bus.$emit("showLoader", true);
      this.$api.driver
        .updateDriverStatus(this.driverID, this.assignmentForm)
        .then(() => {
          this.showDriverStatusChangedDialog = false;
          bus.$emit("showToastMessage", {
            message: "Driver Status updated successfully!",
            color: "success",
          });
          this.$emit("refreshList");
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          this.formErrors = err.data;
          bus.$emit("showToastMessage", {
            message: "Couldn't update driver status!",
            color: "error",
          });
          bus.$emit("showLoader", false);
        });
    },
    getVehicleList() {
      bus.$emit("showLoader", true);
      this.$api.vehicle
        .getVehicleList({ limit: "all", has_assigned: false})
        .then((res) => {
          this.vehicleList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style></style>
